/* Mastichová kalkulačka v2 — doporučovací engine.
 * Čistá logika bez DOM: vstupem je konfigurace (mlk-config.js), katalog (z metaobjektů,
 * sestavuje Liquid sekce) a odpovědi; výstupem strukturované doporučení.
 *
 * Tvar katalogu:
 * {
 *   rady: { strong_pure: { klic, nazev, forma, popis, davkovaniText, mgMasticha|null,
 *                          vychoziDavka|null, slozeni:[{nazev,mnozstvi,jednotka}] }, ... },
 *   baleni: [ { id, rada, jednotek|null, polozky:[{rada,jednotek}]|null, vydrzFixni|null,
 *               nazev, url, obrazek, variantId, cena (minor units), dostupne (bool) }, ... ]
 * }
 */
(function (root) {
  "use strict";

  /* ---------- Vyhodnocování podmínek ---------- */
  function splnenaPodminka(c, a) {
    var extra = a.extra || [], safety = a.safety || [];
    switch (c.p) {
      case "goal": return c.in.indexOf(a.goal) !== -1;
      case "hpylori": return c.in.indexOf(a.hpylori) !== -1;
      case "form": return c.in.indexOf(a.form) !== -1;
      case "intensity": return c.in.indexOf(a.intensity) !== -1;
      case "cilNeboExtra": return a.goal === c.v || extra.indexOf(c.v) !== -1;
      case "safety": return c.maNektery.some(function (v) { return safety.indexOf(v) !== -1; });
      case "extra": return (c.maNektery || []).some(function (v) { return extra.indexOf(v) !== -1; });
      default: return false;
    }
  }
  function splneno(kdyz, a) { return (kdyz || []).every(function (c) { return splnenaPodminka(c, a); }); }

  /* Aktuální hodnota odpovědi, kterou podmínka testuje — jen pro debug trace. */
  function aktualniHodnota(c, a) {
    switch (c.p) {
      case "goal": return a.goal;
      case "hpylori": return a.hpylori;
      case "form": return a.form;
      case "intensity": return a.intensity;
      case "cilNeboExtra": return [a.goal].concat(a.extra || []);
      case "safety": return a.safety || [];
      case "extra": return a.extra || [];
      default: return undefined;
    }
  }

  /* ---------- Kroky ---------- */
  function aktivniKroky(config, a) {
    return config.kroky.filter(function (k) { return !k.zobrazKdyz || splneno(k.zobrazKdyz, a); });
  }
  function aktivniVolby(krok) {
    return krok.volby.filter(function (v) { return v.aktivni !== false; });
  }

  /* ---------- Cíl ze symptomů (větev „nevím") ---------- */
  function cilZeSymptomu(config, symptoms) {
    var score = {};
    (symptoms || []).forEach(function (s) {
      var cil = config.symptomyNaCil[s];
      if (cil) score[cil] = (score[cil] || 0) + 1;
    });
    var best = config.vychoziCil, max = 0;
    Object.keys(score).forEach(function (k) { if (score[k] > max) { max = score[k]; best = k; } });
    return best;
  }

  /* Normalizace odpovědí: doplní efektivní cíl a vyčistí extra. */
  function normalizuj(config, answers) {
    var a = Object.assign({}, answers);
    if (a.goal === "nevim") a.goal = cilZeSymptomu(config, a.symptoms);
    a.extra = (a.extra || []).filter(function (x) { return x && x !== "ne"; });
    a.intensity = a.intensity || "standard";
    return a;
  }

  /* ---------- Dávkování ---------- */
  function davkaProTier(config, davKlic, intensity) {
    var d = config.davkovani[davKlic];
    if (!d) return null;
    return d.vse || d[intensity] || d.standard || null;
  }

  /* Denní dávka v jednotkách dané řady; null = nelze určit (→ bez vydatnosti). */
  function jednotekDenne(rada, davka) {
    if (!davka) return null;
    if (davka.jednotky != null) return davka.jednotky;
    if (davka.mg != null && rada && rada.mgMasticha) return Math.ceil(davka.mg / rada.mgMasticha);
    return null;
  }

  /* ---------- Vydatnost balení ----------
   * Položky: explicitní `polozky`, jinak {rada, jednotek} z balení samotného.
   * Hlavní řada se dávkuje podle pravidla; vedlejší podle vychoziDavka své řady.
   */
  function polozkyBaleni(b) {
    if (b.polozky && b.polozky.length) return b.polozky;
    if (b.jednotek != null) return [{ rada: b.rada, jednotek: b.jednotek }];
    return [];
  }

  function vydrzBaleni(catalog, config, b, hlavniRada, davka) {
    if (b.vydrzFixni != null) return b.vydrzFixni;
    var items = polozkyBaleni(b);
    if (!items.length) return null;
    var min = null;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var rada = catalog.rady[it.rada];
      var denne;
      if (it.rada === hlavniRada) denne = jednotekDenne(rada, davka);
      else {
        var defDavka = davkaProTier(config, config.radaDavkovani[it.rada], "standard");
        denne = (rada && rada.vychoziDavka != null) ? rada.vychoziDavka : jednotekDenne(rada, defDavka);
      }
      if (!denne || denne <= 0) return null;
      var dni = Math.floor(it.jednotek / denne);
      if (min === null || dni < min) min = dni;
    }
    return min;
  }

  /* ---------- Výběr balení v rámci řady ---------- */
  function spocitejMoznosti(catalog, config, radaKlic, davKlic, intensity) {
    var davka = davkaProTier(config, davKlic, intensity);
    var kuraDni = davka ? davka.kuraDni : null;
    var moznosti = catalog.baleni
      .filter(function (b) { return b.rada === radaKlic; })
      .map(function (b) {
        var vydrz = vydrzBaleni(catalog, config, b, radaKlic, davka);
        var pocet = (vydrz && kuraDni) ? Math.ceil(kuraDni / vydrz) : (vydrz ? 1 : null);
        return {
          baleni: b, vydrzDni: vydrz, pocetNaKuru: pocet,
          cenaCelkem: pocet != null ? pocet * b.cena : null,
          cenaNaDen: vydrz ? Math.round(b.cena / vydrz) : null
        };
      });
    return { davka: davka, kuraDni: kuraDni, moznosti: moznosti };
  }

  /* Nejlepší dostupné balení: nejnižší celková cena pokrývající kúru, ale v cenové
   * toleranci (výchozí +5 %) se preferuje méně balení — 1× Economy je lepší doporučení
   * než 5× malé balení o pár korun levněji. Bez kúry/vydatnosti: nejlevnější dostupné. */
  function vyberBaleni(moznosti, config) {
    var dostupne = moznosti.filter(function (m) { return m.baleni.dostupne; });
    if (!dostupne.length) return null;
    var sVydatnosti = dostupne.filter(function (m) { return m.cenaCelkem != null; });
    if (sVydatnosti.length) {
      sVydatnosti.sort(function (x, y) {
        return (x.cenaCelkem - y.cenaCelkem) || (x.pocetNaKuru - y.pocetNaKuru);
      });
      var tolerance = 1 + (config && config.tolerancePoctuBaleni != null ? config.tolerancePoctuBaleni : 0.05);
      var strop = sVydatnosti[0].cenaCelkem * tolerance;
      var vTolerance = sVydatnosti.filter(function (m) { return m.cenaCelkem <= strop; });
      vTolerance.sort(function (x, y) {
        return (x.pocetNaKuru - y.pocetNaKuru) || (x.cenaCelkem - y.cenaCelkem);
      });
      return vTolerance[0];
    }
    dostupne.sort(function (x, y) { return x.baleni.cena - y.baleni.cena; });
    return dostupne[0];
  }

  /* ---------- Pravidla ---------- */
  function vyberPravidlo(config, a, trace) {
    for (var i = 0; i < config.pravidla.length; i++) {
      var r = config.pravidla[i];
      var ok = splneno(r.kdyz, a);
      if (trace) {
        trace.push({
          id: r.id, splneno: ok,
          podminky: (r.kdyz || []).map(function (c) {
            return { p: c.p, ocekava: c.in || c.maNektery || c.v, hodnota: aktualniHodnota(c, a), ok: splnenaPodminka(c, a) };
          })
        });
      }
      if (ok) {
        return {
          id: r.id,
          rada: r.radaDle ? r.radaDle[a.intensity] : r.rada,
          alt: r.altDle ? r.altDle[a.intensity] : r.alt,
          dav: r.dav
        };
      }
    }
    return null;
  }

  function varovani(config, a) {
    var texty = [], lekar = false;
    config.bezpecnost.forEach(function (b) {
      if (splneno(b.kdyz, a)) { texty.push({ id: b.id, cs: b.cs }); if (b.lekar) lekar = true; }
    });
    return { texty: texty, lekar: lekar };
  }

  /* ---------- Bundle pro kombinaci hlavního a vedlejšího cíle ---------- */
  function radyVBaleni(b) {
    return polozkyBaleni(b).map(function (p) { return p.rada; });
  }
  function najdiKombinaci(catalog, config, primarniRada, tipRady) {
    if (!tipRady.length) return null;
    var kandidati = catalog.baleni.filter(function (b) {
      if (!b.dostupne) return false;
      var rady = radyVBaleni(b);
      if (rady.indexOf(primarniRada) === -1 && b.rada !== primarniRada) return false;
      return tipRady.some(function (t) { return rady.indexOf(t) !== -1; });
    });
    if (!kandidati.length) return null;
    kandidati.sort(function (x, y) { return x.cena - y.cena; });
    return kandidati[0];
  }

  /* ---------- Hlavní vstup ---------- */
  function doporuc(catalog, config, answers, opts) {
    var debug = !!(opts && opts.trace);
    var a = normalizuj(config, answers);
    var varov = varovani(config, a);
    var pravidlaLog = debug ? [] : null;
    var pravidlo = vyberPravidlo(config, a, pravidlaLog);
    function trace(extra) {
      if (!debug) return undefined;
      return Object.assign({
        vstup: answers,
        odpovedi: a,
        cilZeSymptomu: (answers && answers.goal === "nevim") ? a.goal : null,
        pravidla: pravidlaLog,
        diagnostika: diagnostikaKatalogu(catalog, config)
      }, extra || {});
    }
    if (!pravidlo) return { chyba: "zadne_pravidlo", varovani: varov.texty, lekar: varov.lekar, trace: trace() };

    /* Primární řada; při nedostupnosti všech balení fallback na alternativu. */
    function slozDoporuceni(radaKlic, davKlic) {
      var rada = catalog.rady[radaKlic];
      if (!rada) return null;
      var vypocet = spocitejMoznosti(catalog, config, radaKlic, davKlic, a.intensity);
      return {
        rada: rada, radaKlic: radaKlic,
        davka: vypocet.davka, kuraDni: vypocet.kuraDni,
        moznosti: vypocet.moznosti,
        vybrane: vyberBaleni(vypocet.moznosti, config)
      };
    }

    var primarni = slozDoporuceni(pravidlo.rada, pravidlo.dav);
    var fallbackPouzit = false;
    if (!primarni || !primarni.vybrane) {
      var nahradni = pravidlo.alt && slozDoporuceni(pravidlo.alt, config.radaDavkovani[pravidlo.alt] || pravidlo.dav);
      if (nahradni && nahradni.vybrane) { primarni = nahradni; fallbackPouzit = true; }
    }
    var alternativa = null;
    if (!fallbackPouzit && pravidlo.alt && pravidlo.alt !== (primarni && primarni.radaKlic)) {
      alternativa = slozDoporuceni(pravidlo.alt, config.radaDavkovani[pravidlo.alt] || pravidlo.dav);
    }

    /* Doplňkové tipy: vedlejší cíle, které primární řada (vč. obsahu vybraného balení) nepokrývá. */
    var pokryto = [];
    if (primarni) {
      pokryto.push(primarni.radaKlic);
      if (primarni.vybrane) pokryto = pokryto.concat(radyVBaleni(primarni.vybrane.baleni));
    }
    var tipy = [];
    a.extra.forEach(function (cil) {
      var tipRada = config.tipy[cil];
      if (tipRada && pokryto.indexOf(tipRada) === -1 && pravidlo.rada !== tipRada && catalog.rady[tipRada]) {
        if (tipy.indexOf(tipRada) === -1) tipy.push(tipRada);
      }
    });

    /* Bundle pokrývající hlavní cíl + tip najednou. */
    var kombinace = primarni ? najdiKombinaci(catalog, config, primarni.radaKlic, tipy) : null;
    if (kombinace && primarni.vybrane && kombinace.id === primarni.vybrane.baleni.id) kombinace = null;

    return {
      odpovedi: a,
      pravidloId: pravidlo.id,
      lekar: varov.lekar,
      varovani: varov.texty,
      primarni: primarni,
      fallbackPouzit: fallbackPouzit,
      alternativa: alternativa,
      tipy: tipy.map(function (k) { return { radaKlic: k, rada: catalog.rady[k] }; }),
      kombinace: kombinace,
      vyprodanoVse: !primarni || !primarni.vybrane,
      trace: trace({ pravidlo: { id: pravidlo.id, rada: pravidlo.rada, alt: pravidlo.alt, dav: pravidlo.dav } })
    };
  }

  /* ---------- Diagnostika katalogu (debug) ----------
   * Najde konfigurační chyby, kvůli kterým engine tiše nevybere produkt:
   * chybějící řady odkazované pravidly/tipy, balení bez spočitatelné vydatnosti
   * (přeskočí se ve výběru), balení bez varianty, řady bez balení.
   */
  function diagnostikaKatalogu(catalog, config) {
    var problemy = [];
    function pridej(uroven, kod, zprava) { problemy.push({ uroven: uroven, kod: kod, zprava: zprava }); }
    if (!catalog || !catalog.rady) return problemy;

    /* Řady odkazované v pravidlech a tipech musí být v katalogu. */
    var odkazovane = {};
    (config.pravidla || []).forEach(function (r) {
      [r.rada, r.alt].forEach(function (k) { if (k) odkazovane[k] = true; });
      [r.radaDle, r.altDle].forEach(function (m) { if (m) Object.keys(m).forEach(function (kk) { odkazovane[m[kk]] = true; }); });
    });
    Object.keys(config.tipy || {}).forEach(function (c) { odkazovane[config.tipy[c]] = true; });
    Object.keys(odkazovane).forEach(function (k) {
      if (!catalog.rady[k]) pridej("chyba", "rada_chybi", 'Řada "' + k + '" je v pravidlech/tipech, ale chybí v katalogu (metaobjekt formula).');
    });

    /* Balení: odkazované řady, spočitatelná vydatnost, varianta, dostupnost. */
    var radyVKatalogu = {};
    (catalog.baleni || []).forEach(function (b) {
      var jmeno = b.nazev || b.id;
      polozkyBaleni(b).forEach(function (it) {
        radyVKatalogu[it.rada] = true;
        if (!catalog.rady[it.rada]) pridej("chyba", "baleni_rada_chybi", 'Balení "' + jmeno + '" odkazuje řadu "' + it.rada + '", která není v katalogu.');
      });
      var davka = davkaProTier(config, config.radaDavkovani[b.rada], "standard");
      if (vydrzBaleni(catalog, config, b, b.rada, davka) == null) {
        pridej("varovani", "baleni_bez_vydatnosti", 'Balení "' + jmeno + '" (řada ' + b.rada + '): nelze určit vydatnost → ve výsledku se přeskočí. Zkontrolujte jednotky / mg / složení řady.');
      }
      if (b.variantId == null) pridej("varovani", "baleni_bez_varianty", 'Balení "' + jmeno + '" nemá variantId → nepůjde přidat do košíku.');
      if (!b.dostupne) pridej("info", "baleni_vyprodano", 'Balení "' + jmeno + '" je nedostupné (dostupne=false).');
    });

    /* Řady bez jediného balení. */
    Object.keys(catalog.rady).forEach(function (k) {
      if (!radyVKatalogu[k]) pridej("varovani", "rada_bez_baleni", 'Řada "' + k + '" nemá v katalogu žádné balení.');
    });

    return problemy;
  }

  var MLK_ENGINE = {
    doporuc: doporuc,
    aktivniKroky: aktivniKroky,
    aktivniVolby: aktivniVolby,
    cilZeSymptomu: cilZeSymptomu,
    diagnostikaKatalogu: diagnostikaKatalogu,
    /* exporty pro testy */
    _internal: { splneno: splneno, vydrzBaleni: vydrzBaleni, spocitejMoznosti: spocitejMoznosti, vyberBaleni: vyberBaleni, normalizuj: normalizuj }
  };

  if (typeof module !== "undefined" && module.exports) module.exports = MLK_ENGINE;
  else root.MLK_ENGINE = MLK_ENGINE;
})(typeof window !== "undefined" ? window : globalThis);
